<template>
  <div class="ct">
    <div class="li"></div>
    <div class="ti">{{ title }}</div>
  </div>
</template>
<script>
export default {
  componentname: "titleline",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.ct {
  display: flex;
  justify-content: flex-start;
  height: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  .li {
    width: 4px;
    height: 20px;
    background-color: #1abc9c;
  }
  .ti {
    line-height: 20px;
    font-size: 16px;
    font-weight: 500;
    margin-left: 15px;
  }
}
</style>

